export default "__VITE_ASSET__D8tS0N3j__"